export const NEW_OFFER_LOOKUP_OPTION_VALUE = '__new__';

export type OfferLookupField = 'countryId' | 'regionId' | 'hotelId';

export type OfferLookupEntityOption = {
  label: string;
  value: number;
  description?: string;
};

export type OfferLookupAddNewOption = {
  label: string;
  value: typeof NEW_OFFER_LOOKUP_OPTION_VALUE;
  description?: string;
};

export type OfferLookupOption = OfferLookupEntityOption | OfferLookupAddNewOption;

export const OFFER_LOOKUP_FIELDS: OfferLookupField[] = ['countryId', 'regionId', 'hotelId'];

const MIN_SEARCH_LENGTH = 3;

export function filterOfferLookupWithAddNew(
  options: OfferLookupOption[],
  { inputValue }: { inputValue: string },
  entityLabel: string
): OfferLookupOption[] {
  const search = inputValue.trim();
  const filteredOptions = filterLookupOptions(options, search);

  if (search.length < MIN_SEARCH_LENGTH) {
    return filteredOptions;
  }

  const hasAddNewOption = filteredOptions.some(
    (option) => option?.value === NEW_OFFER_LOOKUP_OPTION_VALUE
  );
  if (hasAddNewOption) {
    return filteredOptions;
  }

  const normalizedSearch = normalizeLookupText(search);
  const hasExactMatch = filteredOptions.some((option) => {
    if (!option || typeof option.label !== 'string') {
      return false;
    }

    return normalizeLookupText(option.label) === normalizedSearch;
  });

  if (hasExactMatch) {
    return filteredOptions;
  }

  return [
    ...filteredOptions,
    {
      label: `➕ Dodaj ${entityLabel}: "${search}"`,
      value: NEW_OFFER_LOOKUP_OPTION_VALUE,
    },
  ];
}

export function mergeLookupOptions(
  primaryOptions: OfferLookupEntityOption[],
  additionalOptions: OfferLookupEntityOption[]
): OfferLookupEntityOption[] {
  const merged = new Map<number, OfferLookupEntityOption>();

  for (const option of [...primaryOptions, ...additionalOptions]) {
    const key = option.value;
    if (!merged.has(key)) {
      merged.set(key, option);
    }
  }

  return Array.from(merged.values());
}

function normalizeLookupText(value: string): string {
  return value
    .trim()
    .toLocaleLowerCase('pl-PL')
    .replace(/\s+/g, ' ');
}

function filterLookupOptions(
  options: OfferLookupOption[],
  search: string
): OfferLookupOption[] {
  const normalizedSearch = normalizeLookupText(search);
  if (!normalizedSearch) {
    return options;
  }

  return options.filter((option) => {
    const normalizedLabel = normalizeLookupText(option.label);
    const normalizedDescription =
      typeof option.description === 'string' ? normalizeLookupText(option.description) : '';

    return (
      normalizedLabel.includes(normalizedSearch) ||
      normalizedDescription.includes(normalizedSearch)
    );
  });
}
